import request from '@/utils/request';

// 对外暴露登录接口函数
export function login(data) {
  return request({
    url: `/user/login?loginName=${data.loginName}&password=${data.password}`,
    method: 'post',
  })
}

// 对外暴露获取用户信息的函数
export function getInfo(token,loginName) {
  return request({
    url: `/look/user/getUserById?loginName=${loginName}`,
    method: 'get',
    params: { token }
  })
}

// 对外暴露退出登录接口的函数
export function logout() {
  return request({
    url: '/admin/acl/index/logout',
    method: 'post'
  })
}
